import './styles.scss';
import classNames from 'classnames';

const Date = ({
    hidePlaceholder = false,
    ...props
}) => {
    return (
        <>
            <label className={classNames({
                'form__label': true,
                'form__label--hidden': props.hideLabel 
            })} htmlFor={props.id}>
                {hidePlaceholder !== true &&
                    <span>{props.placeholder}</span>
                }
            
                <div className="form__input-container form__input-container--date">
                    <input
                        className="form__input form__input--date" 
                        type="text"
                        placeholder={props.placeholder} 
                        id={props.id} 
                        onFocus={(e) => {
                            e.currentTarget.type = 'date';
                            e.currentTarget.showPicker();
                        }} 
                        onBlur={(e) => {
                            if (e.currentTarget.value === '') {
                                e.currentTarget.type = 'text';
                            }
                        }}
                    />
                </div>
            </label>
        </>
    );
};

export default Date;